import React from "react"
import PropTypes from "prop-types"
import {Form, Input, Modal, Switch} from "antd"

const FormItem = Form.Item;

const EditModal = ({visible, close, lov, saving, form, saveLov, isEdit}) => {
    
    const handleOk = (e) => {
        e.preventDefault();
        form.validateFields(async (err, values) => {
            if (!err) {
                console.log('Save', values);
                await saveLov({...values, code: lov.code});
                close();
                form.resetFields()
            }
        })
    };
    
    const handleCancel = () => {
        close();
        form.resetFields();
    };
    
    const {getFieldDecorator} = form;
    
    const title = isEdit ? `Edit ${lov.label}` : 'Add new LOV';
    
    return <Modal title={title} visible={visible} onCancel={handleCancel} onOk={handleOk}
                  confirmLoading={saving} okText="Save">
        <Form onSubmit={handleOk} layout='horizontal'>
            <FormItem label="Code">
                {
                    getFieldDecorator('code', {
                        rules: [
                            {required: true, message: "Please specify a code", whitespace: true},
                            {max: 50, message: 'The code cannot be longer than 50 characters'}
                        ],
                        initialValue: isEdit ? lov.code : null
                    })(
                        <Input/>
                    )
                }
            </FormItem>
            <FormItem label="Label">
                {
                    getFieldDecorator('label', {
                        rules: [
                            {required: true, message: "Please specify a label", whitespace: true},
                            {max: 50, message: 'The label cannot be longer than 50 characters'}
                        ],
                        initialValue: isEdit ? lov.label : null
                    })(
                        <Input/>
                    )
                }
            </FormItem>
            <FormItem label="Comment">
                {
                    getFieldDecorator('translation', {
                        rules: [{max: 8000, message: 'The comment cannot be longer than 8000 characters'}],
                        initialValue: isEdit ? lov.translation : null
                    })(
                        <Input/>
                    )
                }
            </FormItem>
            <FormItem label="Active">
                {getFieldDecorator('status', {
                    valuePropName: 'checked',
                    initialValue: isEdit ? lov.status : true
                })(
                    <Switch/>
                )}
            </FormItem>
        </Form>
    </Modal>
};

EditModal.propTypes = {
    visible: PropTypes.bool.isRequired,
    lov: PropTypes.object.isRequired,
    close: PropTypes.func.isRequired,
    saving: PropTypes.bool.isRequired,
    saveLov: PropTypes.func.isRequired,
    isEdit: PropTypes.bool.isRequired
};

export default Form.create()(EditModal)


// WEBPACK FOOTER //
// ./src/js/lovs/manage/EditModal.js